const KeenSlider = window.KeenSlider

class BaoShoppableArticleCarousel extends HTMLElement {
  connectedCallback () {
    requestAnimationFrame(() => this.setupCarousel())
  }

  setupCarousel () {
    const slidesEl = this.querySelector(
      '[data-shoppable-carousel-el="slides"]',
    )
    if (!slidesEl) return

    const slideCount = slidesEl.querySelectorAll(
      '[data-shoppable-carousel-el="slide"]',
    ).length
    if (slideCount === 0) return

    // Constrain container to whole slide boundaries (max 6 visible)
    const slideWidth = 40
    const spacing = 4
    const visibleCount = Math.min(slideCount, 6)
    slidesEl.style.width = `${visibleCount * slideWidth + (visibleCount - 1) * spacing}px`

    this.carousel = new KeenSlider(
      slidesEl,
      {
        selector: '[data-shoppable-carousel-el="slide"]',
        loop: false,
        mode: 'free-snap',
        rubberband: false,
        slides: {
          perView: 'auto',
          spacing: 4,
        },
      },
      [window.BAO.Carousel.plugins.setInitialised()],
    )
  }

  disconnectedCallback () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }
  }
}

if (!customElements.get('bao-shoppable-article-carousel')) {
  customElements.define(
    'bao-shoppable-article-carousel',
    BaoShoppableArticleCarousel,
  )
}
